module.exports = __webpack_public_path__ + "img/2-6.d5e3b6a2.png";